import config from '@epi-config';
import { post } from '@epi-helpers/FetchHelpers';

const url = `${config.apiHost}/api/sign-contract`;

export interface SignContractPayload {
  reCaptchaToken: string;
  [key: string]: any;
}

export interface SignContractResponse {
  token: string;
}

export function signContractRequest(
  payload: SignContractPayload
): Promise<SignContractResponse> {
  return post(url, payload);
}
